var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8773 20.5C9.61037 21.4145 10.7368 22 12 22C13.2632 22 14.3896 21.4145 15.1227 20.5H8.8773Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3V3.07893C16.0042 3.55805 18.3 6.16092 18.3 9.3V12.8394C18.3 13.6012 18.4895 14.3509 18.8515 15.0212L19.4069 16.0497C20.1264 17.3822 19.1614 19 17.647 19H6.35299C4.83859 19 3.87361 17.3822 4.59318 16.0497L5.14857 15.0212C5.51051 14.3509 5.70001 13.6012 5.70001 12.8394V9.3C5.70001 6.16092 7.99585 3.55805 11 3.07893V3C11 2.44772 11.4477 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm2);
export default __webpack_public_path__ + "static/media/alarm-2.8ea81e2d60026024d63f70695551889c.svg";
export { ForwardRef as ReactComponent };